import {PartnerState} from './partnerState';
import {PartnerType} from './partnerType';
import {User} from './user';
import { Document } from '../document';

export interface Partner {
  id: number;
  name: string;
  surName: string;
  avatar: string;
  city?: string;
  color?: string;
  comment?: string;
  countryId?: number;
  currencyId?: number;
  email?: string;
  billingEmail?: string;
  employee?: string;
  position?: string;
  isBlacklisted?: boolean;
  isCompany?: boolean;
  isActive?: boolean;
  mobile?: string;
  rut?: string;
  parentId?: number;
  latitude?: number;
  longitude?: number;
  phone?: string;
  stateId?: number;
  state?: PartnerState;
  street?: string;
  street2?: string;
  partnerTypeId?: number;
  partnerType?: PartnerType;
  vat?: string;
  website?: string;
  zip?: string;
  imo?: string;
  user?: User;
  documents?: Document[]
  parentPartner?:{name:string,id:number}
  parent?:{name:string,id:number}
}

export interface PartnerCreate {
  "avatar": string,
  "city": string,
  "color": string,
  "comment": string,
  "countryId": number,
  "currencyId": number,
  "email": string,
  "employee": string,
  "position": string,
  "isBlacklisted": boolean,
  "isCompany": boolean,
  "isActive": boolean,
  "mobile": string,
  "rut"?: string,
  "name": string,
  "surName": string,
  "parentId": number,
  "latitude": number,
  "longitude": number,
  "phone": string,
  "stateId": number,
  "street": string,
  "street2": string,
  "partnerTypeId": number,
  "vat": string,
  "website": string,
  "zip": string,
  "imo": string
}
